import ReactDOM from 'react-dom/client';

import { logger } from './logger';
import { App } from './App';

logger();

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

root.render(<App/>);

(function() {
  const loader = document.getElementById('initial-page-loader-container-app-only');
  loader?.remove();
})();